import React from 'react';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import { Box, Grid2, Typography } from "@mui/material";
import Form from "../../components/Form/Form";
import './contactUs.css'
import Vector from '../../assets/images/Vector';

const ContactUs: React.FC = () => {
    return (
        <Box className='contactUs-page'>
            <Header />
            <Grid2
                className="hero-ourgame"
                container
                alignItems="center"
                justifyContent="center"
            >
                <Typography className="nameSection">
                    Contact Us
                </Typography>

                <Vector className="vector" />

                <Typography className="h1">
                    Get In Touch
                </Typography>
                <Typography className="h3">
                    Be with us from single games to full platforms, our flexible architecture scales with your needs and adapts to market demands.
                </Typography>
            </Grid2>

            <Grid2
                container
                justifyContent="center"
                // alignItems="center"
                className="contact-us-Grid3"
                columns={{ xs: 5, sm: 8, md: 12 }}
                spacing={2}
                zIndex={3}
                marginTop={'7rem'}
            >
                <Grid2 size={{ xs: 12, sm: 5, md: 5, lg: 5 }}
                    // spacing={3}
                    alignItems="start"
                // container
                // justifyContent="center"
                >
                    {/* <Typography className='headerText'>
                        Get In <Box className={'supply'}>Touch</Box>
                    </Typography> */}
                    {/* <Box> */}
                    <Box className={'contact-box-costum'}>
                        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M37.696 12.428L37.525 11.7399C37.2984 11.0716 36.9989 10.4307 36.632 9.82873C35.7977 8.4275 34.6031 7.27863 33.174 6.50322L23.199 1.07538C21.88 0.369285 20.4087 0 18.9145 0C17.4203 0 15.949 0.369285 14.63 1.07538L4.655 6.50322C3.22592 7.27863 2.03128 8.4275 1.197 9.82873C0.825474 10.4255 0.531734 11.0678 0.323 11.7399V12.0075C0.110206 12.7728 0.00154967 13.5636 0 14.3583V28.9217C0.00502003 31.3279 0.957477 33.6341 2.64891 35.3355C4.34033 37.0369 6.63296 37.9949 9.025 38H28.975C30.1602 38 31.3338 37.7652 32.4287 37.309C33.5237 36.8527 34.5186 36.184 35.3566 35.341C36.1947 34.498 36.8595 33.4973 37.313 32.3958C37.7666 31.2944 38 30.1139 38 28.9217V14.3392C37.9659 13.6931 37.864 13.0525 37.696 12.428ZM22.002 18.8305C21.0602 19.3665 19.9966 19.6482 18.9145 19.6482C17.8324 19.6482 16.7688 19.3665 15.827 18.8305L3.42 11.6062C3.477 11.4596 3.54667 11.3195 3.629 11.1857C4.20243 10.2261 5.02303 9.4403 6.004 8.91135L15.979 3.48351C16.8765 2.9916 17.8829 2.73524 18.905 2.73813C19.9331 2.73531 20.9456 2.99157 21.85 3.48351L31.825 8.91135C32.9987 9.54962 33.9328 10.5564 34.485 11.7782L22.002 18.8305Z" fill="white" />
                        </svg>
                        <Box>
                            <Typography className={'txt-1'}>Email</Typography>
                            <Typography className={'txt-2'}>info@8rabbits.com</Typography>
                        </Box>
                    </Box>
                    {/* </Box> */}

                </Grid2>
                <Grid2 size={{ xs: 5, sm: 7, md: 8, lg: 5 }}
                    justifyContent="center"
                    alignItems="center"
                    container
                    width={'80% !important'}
                sx={{background: 'black'}}

                >
                    <Form />
                </Grid2>

            </Grid2>
            <Footer />
        </Box>
    );
};

export default ContactUs;